import { useEffect, useState } from "react";
import { ITimezoneOption } from "react-timezone-select";

interface CountdownProps {
  created_at: string; // wall-clock time in `timezone`
  durationMinutes: number;
  timezone: ITimezoneOption; // must carry the offset AT created_at
}

const Countdown: React.FC<CountdownProps> = ({
  created_at,
  durationMinutes,
  timezone,
}) => {
  // Parse naive string as UTC anchor, then shift by the zone offset
  const naiveUtcMs = Date.parse(created_at.replace(" ", "T") + "Z");
  const startTimeUtc = naiveUtcMs - (timezone.offset ?? 0) * 60 * 60 * 1000;
  const endTimeUtc = startTimeUtc + durationMinutes * 60 * 1000;

  const getRemaining = () => Math.max(endTimeUtc - Date.now(), 0);

  const [timeLeft, setTimeLeft] = useState(getRemaining);

  useEffect(() => {
    setTimeLeft(getRemaining()); // react to prop changes immediately
    const id = setInterval(() => setTimeLeft(getRemaining()), 1000);
    return () => clearInterval(id);
  }, [endTimeUtc]);

  if (timeLeft <= 0) return <div>00:00</div>;

  const mins = Math.floor(timeLeft / 60000);
  const secs = Math.floor((timeLeft / 1000) % 60);
  return (
    <div>
      {mins}:{secs.toString().padStart(2, "0")}
    </div>
  );
};

export default Countdown;
